import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  IonLabel,
  IonList,
  IonItem,
  IonButton,
  IonModal,
  IonContent,
  IonFooter,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import { LabelConfigurationWarningMode } from '../label-configuration/label-configuration.component';
import { convertMinutesToTime } from '../../../services/ecosystems/helper/convertSecondsToTime';

@Component({
  selector: 'app-minuterie-label',
  templateUrl: './minuterie-label.component.html',
  styleUrls: ['./minuterie-label.component.scss'],
  standalone: true,
  imports: [
    IonLabel,
    IonList,
    IonItem,
    IonButton,
    IonModal,
    IonContent,
    IonFooter,
    TranslatePipe,
    GlobalPageHeaderComponent,
  ],
})
export class MinuterieLabelComponent implements OnInit {
  @Input() title?: string;
  @Input() name?: string;
  @Input() value?: string = '';
  @Input() startDate?: number = 0;
  @Input() description?: string;
  @Input() minuteInterval: number = 30;
  @Input() information?: () => void;
  @Input() warningMode?: LabelConfigurationWarningMode =
    LabelConfigurationWarningMode.NONE;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<any>();

  isModalOpen = false;
  selectedValue: any = null;

  public list: any = [];

  constructor() {}

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i });
    }
  }

  openModal() {
    this.isModalOpen = true;

    this.selectedValue = this.startDate;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  selectItem(itemRef: number) {
    this.selectedValue = itemRef;
  }

  confirmSelection() {
    this.onPress.emit(this.selectedValue);
    this.isModalOpen = false;
  }

  callInformation() {
    if (this.information) {
      this.information();
    }
  }

  protected readonly LabelConfigurationWarningMode =
    LabelConfigurationWarningMode;
}
